export const environment = {
    production: false,
    env: 'development',
    siteUrl: 'https://dev.gajea.com',
    mediaBucket: 'media-gajea-website-dev',
    discoveryAgendaLink: 'https://calendar.app.google/Cw5ABvgzi98xJGLa7',
    freeConsultationLink: 'https://calendar.app.google/w576unz9UozD8unT6'
  };
  